import React, { Component } from "react";
import ReactDOM from "react-dom";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import codeimage from "../img/Group 527.png";
import Featurescards from "../Components/Featurescards";
import Quiz from "../Components/Presale/Presale";
import Copy from "../Components/Copy/Copy";
import { useState } from "react";
import axios from "axios";
import WarningIcon from "@material-ui/icons/Warning";
import CircularProgress from "@material-ui/core/CircularProgress";
import presale from '../img/Untitled-1.png'

// import Fileupload from "../Components/Fileupload/Fileupload";

import "./presale.css";

// function File() {
//   const [files, setFiles] = useState([]);

//   const handleChange = (event) => {
//     setFiles(event.target.files);
//   };

//   const uploadFiles = () => {
//     const formData = new FormData();
//     for (let i = 0; i < files.length; i++) {
//       formData.append(`files[${i}]`, files[i]);
//     }
//     console.log("sending request");
//     axios.post("http://localhost:3001/test", formData);
//     console.log(formData);
//   };
//   return (
//     <div className="App">
//       <input
//         type="file"
//         id="file"
//         multiple
//         name="file"
//         onChange={handleChange}
//       />
//       <button onClick={uploadFiles}> Update File </button>
//     </div>
//   );
// }
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={1}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));
const Discussionbody = () => {
  const classes = useStyles();
  const [value, setValue] = React.useState(1);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [datas, setDatas] = useState([]);
  const updateFieldChanged = (index) => (e) => {
    console.log("index: " + index);
    console.log("property name: " + e.target.name);
    let newArr = [...datas]; // copying the old datas array
    newArr[index] = e.target.value; // replace e.target.value with whatever you want to change it to

    setDatas(newArr); // ??
  };
  const [name, setname] = useState("");
  const [data, setdata] = useState([]);
  const [files, setFiles] = useState([]);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const [qCounter, setQCounter] = useState(0);

  // return (
  //     <React.Fragment>
  //         { datas.map( (data, index) => {
  //               <li key={data.name}>
  //                 <input type="text" name="name" value={data.name} onChange={updateFieldChanged(index)}  />
  //               </li>
  //           })
  //         }
  //     </React.Fragment>
  // )

  return (
    <div className="pcc---slider">
      <Container>
        <Grid container justify="center">
          <Grid container justify="center" md={12} className="mt-5 py-md-3">
            <h1>Presale Form</h1>
          </Grid>
          <img src={presale} style={{width:"309px"}} className="img-fluid mb-3" />
          <Grid container justify="center" md={12}>
          
           
            <p style={{padding: "0 41px"}}>Thankyou for the enthusiastic response! We are no longer taking any entries. Congratulations to all those who have made it onto the final list. And for those who didn't see their name, don't loose hope! We still have plans for you.</p>
            

            <Grid
              container
              direction="row"
              justify="center"
              md={11}
              className="mt-4"
            >
              <Grid container direction="row" justify="center"></Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default Discussionbody;
